var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { AttendeeChangeType } from "@brushfire/types";
import { Text, CurrencyInput } from "@brushfire/ui";
import { useIntl } from "react-intl";
import { ProgressBar } from "react-bootstrap";
import ReactSelect from "react-select";
import { convertCurrencyStrToDecimal } from "../../../../../data/helpers";
import { isNil } from "lodash";
var AllowedPaymentsDropdown = function (_a) {
    var _b;
    var attendeeTypeItem = _a.attendeeTypeItem, id = _a.id, name = _a.name, currencyLocale = _a.currencyLocale, disabled = _a.disabled, formikContext = _a.formikContext, attendeeChanges = _a.attendeeChanges, _c = _a.isAfterPayment, isAfterPayment = _c === void 0 ? false : _c, _d = _a.currentAttendeeTypePrice, currentAttendeeTypePrice = _d === void 0 ? null : _d;
    var intl = useIntl();
    var _e = __read(useState(null), 2), remainingAmount = _e[0], setRemainingAmount = _e[1];
    var _f = __read(useState(null), 2), setRemainingNumber = _f[1];
    var _g = __read(useState(null), 2), selectedOption = _g[0], setSelectedOption = _g[1];
    var _h = __read(useState(false), 2), showCustomInput = _h[0], setShowCustomInput = _h[1];
    var _j = __read(useState(0), 2), amount = _j[0], setAmount = _j[1];
    var currentAmountIndex = attendeeTypeItem.allowedPayments.findIndex(function (x) { return x.toString() === (amount === null || amount === void 0 ? void 0 : amount.toString()); });
    var currentDisplayAmount = currentAmountIndex >= 0 ? (_b = attendeeTypeItem.allowedDisplayPayments) === null || _b === void 0 ? void 0 : _b[currentAmountIndex] : null;
    var allowCustomAmount = attendeeTypeItem.paymentAmounts.includes("*") && isAfterPayment;
    var fieldData = attendeeTypeItem.allowedPayments.map(function (amount, index) {
        var _a, _b, _c;
        return {
            value: amount.toString(),
            label: intl.formatNumber((_b = (_a = attendeeTypeItem.allowedDisplayPayments) === null || _a === void 0 ? void 0 : _a[index]) !== null && _b !== void 0 ? _b : amount, {
                style: "currency",
                currency: currencyLocale,
            }) +
                " of " +
                intl.formatNumber((_c = attendeeTypeItem.displayAmount) !== null && _c !== void 0 ? _c : 0, {
                    style: "currency",
                    currency: currencyLocale,
                }),
            isDisabled: !!attendeeChanges &&
                ((attendeeChanges === AttendeeChangeType.None && amount === currentAttendeeTypePrice) ||
                    (attendeeChanges === AttendeeChangeType.Positive && amount < (currentAttendeeTypePrice !== null && currentAttendeeTypePrice !== void 0 ? currentAttendeeTypePrice : 0))),
        };
    });
    if (allowCustomAmount) {
        fieldData.push({ value: "Custom Amount", label: "Custom Amount" });
    }
    useEffect(function () {
        if (attendeeTypeItem.displayAmount && !isNil(currentDisplayAmount)) {
            var remaining = attendeeTypeItem.displayAmount - currentDisplayAmount > 0
                ? attendeeTypeItem.displayAmount - currentDisplayAmount
                : 0;
            setRemainingNumber(remaining);
            setRemainingAmount(intl.formatNumber(remaining, {
                style: "currency",
                currency: currencyLocale,
            }));
        }
    }, [selectedOption, currentDisplayAmount, amount]);
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (!!attendeeChanges) {
            setSelectedOption((_b = (_a = fieldData.find(function (opt) { return !opt.isDisabled; })) !== null && _a !== void 0 ? _a : fieldData.find(function (opt) { var _a; return opt.value === ((_a = attendeeTypeItem.selectedAmount) === null || _a === void 0 ? void 0 : _a.toString()); })) !== null && _b !== void 0 ? _b : fieldData[0]);
            setAmount(parseInt((_f = (_d = (_c = fieldData.find(function (opt) { return !opt.isDisabled; })) === null || _c === void 0 ? void 0 : _c.value) !== null && _d !== void 0 ? _d : (_e = fieldData.find(function (opt) { var _a; return opt.value === ((_a = attendeeTypeItem.selectedAmount) === null || _a === void 0 ? void 0 : _a.toString()); })) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : fieldData[0].value));
            formikContext === null || formikContext === void 0 ? void 0 : formikContext.setFieldValue(name, parseInt((_h = (_g = fieldData.find(function (opt) { return !opt.isDisabled; })) === null || _g === void 0 ? void 0 : _g.value) !== null && _h !== void 0 ? _h : fieldData[0].value));
        }
        else {
            setSelectedOption((_j = fieldData.find(function (opt) { var _a; return opt.value === ((_a = attendeeTypeItem.selectedAmount) === null || _a === void 0 ? void 0 : _a.toString()); })) !== null && _j !== void 0 ? _j : fieldData[0]);
            setAmount(attendeeTypeItem.selectedAmount);
        }
    }, []);
    return (_jsxs(_Fragment, { children: [_jsx(ReactSelect, { options: fieldData, name: "allowed-payment-dropdown", value: selectedOption !== null && selectedOption !== void 0 ? selectedOption : null, onBlur: function () {
                    formikContext === null || formikContext === void 0 ? void 0 : formikContext.setFieldTouched(name, true);
                }, onChange: function (option) {
                    if (option.value === "Custom Amount") {
                        setShowCustomInput(true);
                        setAmount(0);
                        setSelectedOption(option);
                    }
                    else {
                        setSelectedOption(option);
                        setAmount(option.value);
                        setShowCustomInput(false);
                        formikContext === null || formikContext === void 0 ? void 0 : formikContext.setFieldValue(name, option.value);
                    }
                }, inputId: id, isDisabled: disabled, isSearchable: false, className: "react-select-container", classNamePrefix: "react-select", "aria-label": "Payment Options", onMenuOpen: function () {
                    formikContext === null || formikContext === void 0 ? void 0 : formikContext.setStatus(__assign(__assign({}, formikContext.status), { menuOpen: true }));
                }, onMenuClose: function () {
                    formikContext === null || formikContext === void 0 ? void 0 : formikContext.setStatus(__assign(__assign({}, formikContext.status), { menuOpen: false }));
                } }), showCustomInput && (_jsx(CurrencyInput, { label: "Custom Price", id: "custom-price ".concat(attendeeTypeItem.name), name: "custom-payment", isFieldRequired: true, currency: currencyLocale, onChange: function (e) {
                    setAmount(convertCurrencyStrToDecimal(e.target.value, intl, currencyLocale));
                }, onBlur: function (e) {
                    formikContext === null || formikContext === void 0 ? void 0 : formikContext.setFieldValue(name, convertCurrencyStrToDecimal(e.target.value, intl, currencyLocale));
                }, defaultValue: intl.formatNumber(0, {
                    style: "currency",
                    currency: currencyLocale,
                }), hiddenLabel: true, disabled: disabled, className: "field w-100" })), !isNil(currentDisplayAmount) && attendeeTypeItem.displayAmount && (_jsx(ProgressBar, { now: parseFloat(((currentDisplayAmount / attendeeTypeItem.displayAmount) * 100).toFixed(1)), label: "".concat(((currentDisplayAmount / attendeeTypeItem.displayAmount) * 100).toFixed(1), "%"), srOnly: true })), _jsx(Text.Mini, __assign({ className: "d-block ta-center" }, { children: currentDisplayAmount === parseFloat(fieldData[0].value)
                    ? "Full balance due by ".concat(attendeeTypeItem.paymentsDueBy)
                    : "".concat(remainingAmount, " balance due by ").concat(attendeeTypeItem.paymentsDueBy) }))] }));
};
export default AllowedPaymentsDropdown;
